import { RoleList, RolePrivilege, RoleRepositories, roleMapping, RoleData, BircodeData } from "./types"
import store from "stores/store"
import { RpUser } from 'screens/login/stores/types';

/**
 * @param user 
 * @returns Bircode Data extracted from user.
 */
export const getBircodeDataFromUser = (user: RpUser | undefined): BircodeData | undefined => {
    let selectedBircodeData: BircodeData | undefined = undefined
    let bircodeDataString = localStorage.getItem("bircodeData");
    let myRoleData = getRoleDataFromUser(user)
    if (bircodeDataString) selectedBircodeData = JSON.parse(bircodeDataString)
    if (myRoleData.myRolePrivilege === RolePrivilege.R1 && !bircodeDataString) {
        if (user && user.bircode) {
            selectedBircodeData = {
                bircode: user.bircode,
                businessName: "",
                city: ""
            }
        }
    }
    return selectedBircodeData;
}

/**
 * @param user 
 * @returns Role data extracted from user.
 */
export const getRoleDataFromUser = (user: RpUser | undefined): RoleData => {
    const roleList = getRoleListFromUser(user)
    const rolePrivilege = getRolePrivilegeFromUser(user)

    return {
        myRoleList: roleList,
        myRolePrivilege: rolePrivilege
    }
}

/**
 * @param user
 * @returns Role list extracted from user.
 */
export const getRoleListFromUser = (user: RpUser | undefined): RoleList => {
    let roles: Array<string> = [];
    RoleRepositories.forEach(repository => {
        if (user && user.profile && user.profile[repository] && typeof user.profile[repository] === 'string') {
            roles = [...roles, user?.profile[repository]]
        }
        else if (user && user.profile && user.profile[repository] && typeof user.profile[repository] !== 'string') {
            user.profile[repository].forEach((role: string) => roles = [...roles, role])
        }

    })
    return roles
}

/**
 * @param user
 * @returns Role privilege extracted from user.
 */
export const getRolePrivilegeFromUser = (user: RpUser | undefined): RolePrivilege => {
    let currentRolePrivilege: RolePrivilege = RolePrivilege.NONE;
    const roleList = getRoleListFromUser(user);

    roleMapping.forEach(roleMapping => {
        if (roleList && roleMapping.roles.some((ai: string) => roleList.includes(ai)) && roleMapping.privilege > currentRolePrivilege)
            currentRolePrivilege = roleMapping.privilege
    });

    return currentRolePrivilege
}

/**
 * @param requiredRolePrivilege Required Role Privilege to access ressource.
 * @returns boolean : True if granted, else is false.
 */
export const isRolePrivilegeGranted = (requiredRolePrivilege: RolePrivilege): boolean => {
    const myRolePrivilege: RolePrivilege = store.getState().rp4.roles.roleData.myRolePrivilege;
    return myRolePrivilege >= requiredRolePrivilege
}
